<!-- src/app/pages/privacy/privacy.component.html -->
<section class="privacy-page">
  <div class="container">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Last updated: March 27, 2026</p>

    <p class="intro">
      Lydia Christensen for United States Senate ("the Campaign") is committed to protecting your privacy.
      This policy explains what information we collect, how we use it, and your rights regarding that information.
    </p>

    <div class="section">
      <h2>1. Information We Collect</h2>
      <h3>Information you provide directly</h3>
      <p>When you use our contact forms, volunteer signup, petition, or newsletter, we may collect:</p>
      <ul>
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Mailing address and ZIP code</li>
        <li>Michigan county</li>
        <li>Your stated volunteer interests or message</li>
      </ul>
      <h3>FEC-required information</h3>
      <p>
        Federal law requires campaigns to collect and report the <strong>name, address, employer, and occupation</strong>
        of anyone who contributes more than $200 in an election cycle. This information is reported to the
        Federal Election Commission and becomes part of the public record.
      </p>
      <h3>Automatically collected information</h3>
      <p>When you visit this site, we automatically collect:</p>
      <ul>
        <li><strong>Google Analytics 4 (GA4):</strong> Pages visited, session duration, general geographic region, browser type, and traffic source. This data is anonymized and aggregated.</li>
        <li><strong>Facebook/Meta Pixel:</strong> Page views and certain conversion events to measure the effectiveness of campaign outreach. See <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer">Meta's Privacy Policy</a> for details.</li>
      </ul>
    </div>

    <div class="section">
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To respond to your messages and inquiries</li>
        <li>To send campaign updates, press releases, and event announcements if you opt in</li>
        <li>To coordinate volunteer activities and petition drives</li>
        <li>To process and report donations as required by federal law</li>
        <li>To understand how people use our website so we can improve it</li>
      </ul>
      <p>We do <strong>not</strong> sell, rent, or trade your personal information to any third party for commercial purposes.</p>
    </div>

    <div class="section">
      <h2>3. Third-Party Services</h2>
      <p>We use the following third-party services to operate this site. Each has its own privacy policy:</p>
      <ul>
        <li><strong>Donorbox</strong> - secure donation processing</li>
        <li><strong>EmailJS</strong> - form submission email delivery</li>
        <li><strong>Google Analytics 4</strong> - site analytics (data processed by Google)</li>
        <li><strong>Meta Pixel</strong> - campaign outreach analytics (data processed by Meta)</li>
      </ul>
    </div>

    <div class="section">
      <h2>4. Data Retention</h2>
      <p>
        We retain contact and volunteer information for the duration of the campaign and as required by FEC
        recordkeeping rules (generally three years after the election). You may request deletion of your
        information at any time, subject to our legal obligations.
      </p>
    </div>

    <div class="section">
      <h2>5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request a copy of the information we hold about you</li>
        <li>Request correction of inaccurate information</li>
        <li>Opt out of campaign communications at any time by replying "UNSUBSCRIBE" to any email</li>
        <li>Disable Google Analytics tracking by installing the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">GA Opt-out Browser Add-on</a></li>
      </ul>
    </div>

    <div class="section">
      <h2>6. Security</h2>
      <p>
        We use industry-standard security practices to protect your data. Donation processing is handled
        entirely by Donorbox and is never stored on our servers.
      </p>
    </div>

    <div class="section">
      <h2>7. Contact</h2>
      <p>
        Questions about this policy? Contact us at
        <a routerLink="/contact">lydialynnchristensen.com/#/contact</a> or email
        <a href="mailto:senator@lydialynnchristensen.com">senator@lydialynnchristensen.com</a>.
      </p>
    </div>

    <div class="fec-note">
      <p>
        Paid for by Lydia Christensen for United States Senate, Lydia Christensen, Treasurer.
        FEC ID: C00903575. For more information on FEC disclosure requirements, visit
        <a href="https://www.fec.gov" target="_blank" rel="noopener noreferrer">fec.gov</a>.
      </p>
    </div>
  </div>
</section>
